module.exports = __webpack_public_path__ + "ad9e3ca555bdbbbec6674eb895b0ae66.MP3";